import { Injectable, inject } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';

/**
 * Class for sending api requests to the server
 */
@Injectable()
export class ApiService {
    private httpClient = inject(HttpClient);

    readonly requestUri: string;
    readonly requestHeaders: HttpHeaders;

    constructor() {
        this.requestUri = environment.apiUrl;
        this.requestHeaders = new HttpHeaders({
            'Content-Type': 'application/json'
        });
    }

    /**
     * Return the options for the http calls
     */
    private getOptions(responseType: string): Record<string, unknown> {
        return {
            observe: 'response',
            headers: this.requestHeaders,
            responseType
        };
    }

    /**
     * Send a get request to the api server
     */
    public get<T>(url: string, responseType = 'json'): Promise<T> {
        return this.httpClient.get<T>(`${this.requestUri}${url}`, this.getOptions(responseType)).toPromise();
    }

    /**
     * Send a get request to the api server
     */
    public getAttachment(url: string, contentType = 'application/pdf'): Promise<Blob> {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', contentType);
        return this.httpClient.get(`${this.requestUri}${url}`, {headers, responseType: 'blob'}).toPromise();
    }

}
